export const formatCheckInTime = (isoString: string | null | undefined) => {
  if (!isoString) return { date: '-', time: '-' };

  try {
    const date = new Date(isoString);

    date.setHours(date.getHours() + 3);

    const formattedDate = date.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const formattedTime = date.toLocaleTimeString('ru-RU', {
      hour: '2-digit',
      minute: '2-digit',
    });

    return { date: formattedDate, time: formattedTime };
  } catch {
    return { date: '-', time: '-' };
  }
};
